import { cloneDeep } from "lodash";
import { HierarchyContextProps, IHierarchyActionUpdateHierarchy } from "../interface";
import { hcr_checkDRs } from "./hcr_checkDRs";
import { hcr_checkSingles } from "./hcr_checkSingles";
import { hcr_updateChangedFlag } from "./hcr_updateChangedFlag";

/**
 * Applies editable hierarchy field updates and refreshes validation blockers.
 *
 * @param state - The current hierarchy context state.
 * @param action - The update-hierarchy action to apply.
 * @returns The updated hierarchy context state.
 */
export const hcr_updateHierarchy = (
  state: HierarchyContextProps,
  action: IHierarchyActionUpdateHierarchy,
): HierarchyContextProps => {
  if (!state.hierarchy)
    throw new Error(`hierarchyContextReducer: ${action.operation}: Hierarchy not assigned`);

  const newState: HierarchyContextProps = {
    ...state,
    hierarchy: {
      ...state.hierarchy,
      ...action.hierarchy,
    },
    isNameChanged:
      typeof action.isNameChanged === "boolean" ? action.isNameChanged : state.isNameChanged,
  };

  if (action.savedHierarchy) {
    newState.savedHierarchy = cloneDeep(action.savedHierarchy);
  }

  return hcr_updateChangedFlag(hcr_checkSingles(hcr_checkDRs(newState)), action);
};
